
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import PhoneInTalkOutlinedIcon from '@mui/icons-material/PhoneInTalkOutlined';
import { AccordionDetails, Box } from '@mui/material';
import ManageWebApi from 'api/application/manageWeb';
import BtnFacebook from 'assets/button/BtnFacebook';
import BtnIG from 'assets/button/BtnIG';
import BtnLine from 'assets/button/BtnLine';
import BtnTiktok from 'assets/button/BtnTiktok';
import BtnWebsite from 'assets/button/BtnWebsite';
import Loading from 'component/Loading';
import { notiError, notiSuccess } from 'component/notifications/notifications';
import * as UseStyles from 'features/application/manage-web/contact-us/style';
import moment from 'moment';
import MainButton from 'new-components/buttons/main-button';
import AlertModal from 'new-components/modal/alert-modal';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getBoolean } from 'utils/app.utils';
import ContactUsForm from './contact-us-form';

type DayProps = 'Sun' | 'Mon' | 'Tue' | 'Wed' | 'Thu' | 'Fri' | 'Sat'
const ContactUs = () => {
    const { t } = useTranslation()
    const t_CONTACTUS = "MANAGE_WEB.CONTACT_US"
    const [load, setLoad] = useState<boolean>(false)
    const [branchContact, setBranchContact] = useState<any>([])
    const [dataEdit, setDataEdit] = useState<any>({})
    const [statusAdd, setStatusAdd] = useState<boolean>(false)
    const [isEdit, setIsEdit] = useState<boolean>(false)
    const [isKeyEdit, setIsKeyEdit] = useState<any>(null)
    const [webContact, setWebContact] = useState<any>([]);
    const [name, setName] = useState<any>('');
    const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
    const [branchId, setBrandId] = useState<any>();

    const Day = { Sun: t('MANAGE_WEB.DAY.SUN'), Mon: t('MANAGE_WEB.DAY.MON'), Tue: t('MANAGE_WEB.DAY.TUE'), Wed: t('MANAGE_WEB.DAY.WED'), Thu: t('MANAGE_WEB.DAY.THU'), Fri: t('MANAGE_WEB.DAY.FRI'), Sat: t('MANAGE_WEB.DAY.SAT') }

    useEffect(() => {
        loadData()
    }, [])


    const loadData = async () => {
        setLoad(false)
        try {
            const contact = await ManageWebApi.getContactUs();
            setBranchContact(contact.data);
            if (contact.data?.length !== 0) {
                const arr = await Promise.all(contact.data.map(async (item: any) => {
                    const res = await ManageWebApi.getWebContactUs(item.branchId);
                    return Object.assign(res.data, { name: item.branchName, isEdit: res.data.name !== undefined, isPull: res.data.name !== undefined });
                }));

                arr.sort((obj1, obj2) => obj1.branchId - obj2.branchId);
                setWebContact(arr);
                setLoad(true)
            }
        }
        catch (error) {
            console.error("Error:", error);
        } finally {
            setLoad(false);
        }
    };


    const onEdit = (i: number, status: boolean, item?: any, key?: number) => {
        if (item && item.name !== undefined) {
            setDataEdit({ ...item })
            const newWebContact = [...webContact]
            newWebContact[i].isPull = !status
            newWebContact[i].isEdit = status
            setWebContact(newWebContact)
            setIsEdit(status)
            setIsKeyEdit(key)
        } else {
            const newWebContact = [...webContact]
            newWebContact[i].isPull = !status
            setWebContact(newWebContact)
            setDataEdit({})
        }

        if (status && item.name !== undefined) {
            setDataEdit({})
        }
    }


    const onDel = async (id: number, name: string) => {
        setName(name)
        setIsOpenAlertModal(true)
        setBrandId(id)
    }

    const handleDelete = async () => {
        try {
            const resDel = await ManageWebApi.delWebContactUs(branchId);
            if (resDel === "pass") {
                loadData();
                setDataEdit({});
                notiSuccess(t(`${t_CONTACTUS}.DEL_SUC`));
            } else {
                notiError(t(`${t_CONTACTUS}.SAVE_ERROR`));
            }
        } catch (error) {
            notiError(t(`${t_CONTACTUS}.SAVE_ERROR`));
        } finally {
            setIsOpenAlertModal(false)
        }
    };


    const renderTimeWork = useCallback((officeTimes: any[]) => {
        const renderTime = (time: string) =>
            moment(time, 'HH:mm:ss').format('HH:mm')

        const dayOrder: DayProps[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

        const renderDay = (days: DayProps[]) => {
            if (!days || days.length === 0) return '';
            if (days.length === 7) return t('MANAGE_WEB.CONTACT_US.OPEN');

            const sortedDays = days.sort((a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b));

            const ranges: string[] = [];
            let rangeStart = 0;

            for (let i = 1; i <= sortedDays.length; i++) {
                if (
                    i === sortedDays.length ||
                    dayOrder.indexOf(sortedDays[i]) !== dayOrder.indexOf(sortedDays[i - 1]) + 1
                ) {
                    const currentRange = sortedDays.slice(rangeStart, i);
                    if (currentRange.length > 1) {
                        ranges.push(`${Day[currentRange[0]]} - ${Day[currentRange[currentRange.length - 1]]}`);
                    } else {
                        ranges.push(Day[currentRange[0]]);
                    }
                    rangeStart = i;
                }
            }

            return ranges.join(', ');
        };

        const grouped = (officeTimes || []).reduce<Record<string, string[]>>((acc, item) => {
            const timeKey = `${item.timeIn}-${item.timeOut}`;
            const statusKey = item.officeStatus === 'CLOSE' ? 'CLOSE_WORK' : 'OPEN_WORK';
            const finalKey = `${statusKey}_${timeKey}`;

            const label = `${renderDay(item.day)} ${item.officeStatus === 'OPEN' ? `${renderTime(item.timeIn)} น. - ${renderTime(item.timeOut)} น.` : ''}`;
            if (!acc[finalKey]) acc[finalKey] = [];
            acc[finalKey].push(label);

            return acc;
        }, {});

        const result: { type: string, value: string[] }[] = [];
        Object.entries(grouped).forEach(([key, value]) => {
            const [status, time] = key.split('_');
            result.push({
                type: status,
                value: [value.join(', ')]
            });
        });

        return (officeTimes || []).map(item => ({
            type: item.officeStatus === 'CLOSE' ? 'CLOSE_WORK' : 'OPEN_WORK',
            value: [`${renderDay(item.day)} ${item.officeStatus === 'OPEN' ? `${renderTime(item.timeIn)} น. - ${renderTime(item.timeOut)} น.` : ''}`],
        }));
    }, [t]);

    const onSave = async (ele: any, i: number) => {
        const { status, newPayload, pass } = ele
        if (pass === 'pass') {
            notiSuccess(t(`${t_CONTACTUS}.SAVE_SUC`))

            const dayOrder = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
            const groupOfficeTimes = (officeTimes: any[]) => {
                if (!officeTimes || officeTimes.length === 0) {
                    return [];
                }
                const groupedByTime = officeTimes.reduce((acc: any, curr: any) => {
                    const key = `${curr.timeIn}-${curr.timeOut}-${curr.officeStatus}`;
                    if (!acc[key]) {
                        acc[key] = {
                            timeIn: curr.timeIn,
                            timeOut: curr.timeOut,
                            officeStatus: curr.officeStatus,
                            day: []
                        };
                    }
                    acc[key].day.push(curr.dayOfWeek);
                    return acc;
                }, {});

                const result: any[] = Object.values(groupedByTime);
                result.forEach((group: any) => {
                    group.day.sort((a: string, b: string) => dayOrder[a as DayProps] - dayOrder[b as DayProps]);
                });
                return result;
            }

            const newWebContact = [...webContact]
            const payloadWithGroupedTimes = {
                ...newPayload,
                officeTimes: groupOfficeTimes(newPayload.officeTimes)
            };

            newWebContact[i] = { ...newWebContact[i], ...payloadWithGroupedTimes, isEdit: true }
            setWebContact(newWebContact)
            setDataEdit({})
            setIsKeyEdit(null)
        } else if (pass === 'error') {
            notiError(t(`${t_CONTACTUS}.SAVE_ERROR`))
        } else {
            webContact[i].isEdit = status
            loadData()
        }
    }

    return (
        <>
            <Loading show={load} />
            <AlertModal
                title={t('MANAGE_WEB.TITLE_DEL')}
                message={`${t(t_CONTACTUS + '.NOTI_DEL_START')} ${name} ${t(t_CONTACTUS + '.NOTI_DEL_END')}`}
                isOpen={isOpenAlertModal}
                type='error'
                handleClose={() => setIsOpenAlertModal(false)}
                onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
                onSubmit={{ onClick: () => handleDelete(), title: t('BUTTON.SUBMIT') }}
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'auto' }}>
                {webContact.map((item: any, index: number) => {
                    return (
                        <UseStyles.Accordion key={item.branchId} defaultExpanded={false} className={` ${!getBoolean(true) ? 'd-none' : ''} w-100`}>
                            <UseStyles.AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
                                <div className={'header-text'}>
                                    <h6 className={'m-0'}>{`${item.name}`}</h6>
                                </div>
                            </UseStyles.AccordionSummary>
                            <AccordionDetails>
                                {item.isEdit && <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: { xs: 'column', md: 'row' },
                                            alignItems: { xs: 'flex-start', md: 'center' },
                                            justifyContent: { xs: 'flex-start', md: 'space-between' },
                                            gap: 2,
                                            mb: 2
                                        }}
                                    >
                                        <Box sx={{ fontSize: { xs: 18, md: 20 }, fontWeight: 600, width: { xs: '100%', md: 'auto' } }}>
                                            {t(`${t_CONTACTUS}.TITLE`)}
                                        </Box>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                gap: 1,
                                                width: { xs: '100%', md: 'auto' },
                                                justifyContent: { xs: 'flex-start', md: 'flex-end' }
                                            }}
                                        >
                                            <MainButton
                                                type="primary"
                                                variant="outlined"
                                                title={t(`${t_CONTACTUS}.BTN_EDIT`)}
                                                onClick={() => onEdit(index, false, item, index)}
                                                style={{ flex: { xs: 1, sm: 0 }, width: '120px' }}
                                            />
                                            <MainButton
                                                type="danger"
                                                variant="contained"
                                                title={t(`${t_CONTACTUS}.BTN_DEL`)}
                                                onClick={() => onDel(item.branchId, item.name)}
                                                style={{ flex: { xs: 1, sm: 0 }, width: '120px' }}
                                            />
                                        </Box>
                                    </Box>
                                    <Box>
                                        <Box sx={{ marginTop: '16px', height: 'fit-content', overflow: 'auto', transition: "all 0.2s", }}>
                                            <Box sx={{ display: 'flex', flexWrap: 'nowrap', minWidth: 'max-content', marginTop: "8px" }}>
                                                <Box sx={{ marginRight: '8px', minWidth: 'fit-content', fontWeight: '400', fontSize: '16px', display: 'flex', flexDirection: 'row' }}>
                                                    <MailOutlinedIcon sx={{ color: '#808080', width: '24px', height: '24px' }} /> <Box marginLeft={1}>{item?.email || ''}</Box>
                                                </Box>
                                            </Box>
                                            <Box sx={{ display: 'flex', flexWrap: 'nowrap', minWidth: 'max-content', marginTop: "8px" }}>
                                                <Box sx={{ marginRight: '8px', minWidth: 'fit-content', fontWeight: '400', fontSize: '16px', display: 'flex', flexDirection: 'row' }}>
                                                    <PhoneInTalkOutlinedIcon sx={{ color: '#808080', width: '24px', height: '24px' }} /> <Box marginLeft={1}>{item?.phone || ''}</Box>
                                                </Box>
                                            </Box>
                                            <Box sx={{ display: 'flex', flexWrap: 'nowrap', marginTop: "8px" }}>
                                                <Box sx={{ marginRight: '8px', minWidth: 'fit-content', fontWeight: '400', fontSize: '16px', display: 'flex', flexDirection: 'row' }}>
                                                    <MapOutlinedIcon sx={{ color: '#808080', width: '24px', height: '24px' }} /> <Box marginLeft={1}>{item?.detail || ''}</Box>
                                                </Box>
                                            </Box>
                                            {renderTimeWork(item.officeTimes).map((group, idx) => (<Box key={idx} sx={{ display: 'flex', flexWrap: 'nowrap', minWidth: 'max-content', marginTop: "8px" }}>
                                                <Box sx={{ marginRight: '16px', minWidth: 'fit-content', fontWeight: '400', fontSize: '16px', display: 'flex', flexDirection: 'row' }}>
                                                    {idx === 0 && <AccessTimeOutlinedIcon sx={{ color: '#808080', width: '24px', height: '24px' }} />}
                                                    {idx === 1 && <Box sx={{ width: '24px', height: '24px' }} />}
                                                    <Box key={idx} sx={{ mb: 1, display: 'flex', flexDirection: 'column' }}>
                                                        <Box sx={{ ml: 1, fontWeight: 'bold' }}>
                                                            {t(`MANAGE_WEB.CONTACT_US.${group.type}`)}
                                                        </Box>
                                                        {group.value.map((timeStr, i) => (
                                                            <Box key={i} sx={{ ml: 2, minWidth: 'fit-content' }}>{timeStr}</Box>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Box>))}
                                        </Box>
                                        <Box sx={{ marginTop: '32px', height: 'fit-content', overflow: 'auto', transition: "all 0.2s", }}>
                                            <Box
                                                sx={{
                                                    iframe: { width: '50%', height: '300px' }
                                                }}
                                                dangerouslySetInnerHTML={{
                                                    __html: `${item?.addressMap ?? ''}`
                                                }}
                                            />
                                        </Box>
                                        <UseStyles.ContainerSocial>
                                            <Box sx={{ width: '10%', paddingRight: '30px' }}><BtnWebsite color="#808080" /></Box>
                                            <Box sx={{ width: '90%' }}>
                                                {item?.website || ''}
                                            </Box>
                                        </UseStyles.ContainerSocial>
                                        <UseStyles.ContainerSocial>
                                            <Box sx={{ width: '10%', paddingRight: '30px' }}><BtnFacebook color="#808080" /></Box>
                                            <Box sx={{ width: '90%' }}>
                                                {item?.facebook || ''}
                                            </Box>
                                        </UseStyles.ContainerSocial>
                                        <UseStyles.ContainerSocial>
                                            <Box sx={{ width: '10%', paddingRight: '30px' }}><BtnLine color="#808080" /></Box>
                                            <Box sx={{ width: '90%' }}>
                                                {item?.line || ''}
                                            </Box>
                                        </UseStyles.ContainerSocial>
                                        <UseStyles.ContainerSocial>
                                            <Box sx={{ width: '10%', paddingRight: '30px' }}><BtnIG color="#808080" width='26' height='26' /></Box>
                                            <Box sx={{ width: '90%' }}>
                                                {item?.instagram || ''}
                                            </Box>
                                        </UseStyles.ContainerSocial>
                                        <UseStyles.ContainerSocial>
                                            <Box sx={{ width: '10%', paddingRight: '30px' }}><BtnTiktok color="#808080" /></Box>
                                            <Box sx={{ width: '90%' }}>
                                                {item?.tiktok || ''}
                                            </Box>
                                        </UseStyles.ContainerSocial>
                                    </Box>
                                </Box> || <ContactUsForm
                                        dataContact={isKeyEdit === index ? dataEdit : {}}
                                        branchContact={branchContact}
                                        index={index}
                                        branchId={item?.branchId}
                                        status={item.isEdit}
                                        setStatus={(e) => { onSave(e, index) }}
                                    />
                                }
                            </AccordionDetails>
                        </UseStyles.Accordion>
                    )
                })}
            </Box >
        </>
    )
}

export default ContactUs

